import { createCRUDHook } from './createCRUDHook';
import { CutDto } from 'utils/models';
import { TLKP_CUT } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<CutDto>({
  entityName: 'Cut',
  endpoint: TLKP_CUT,
});

export const CutContext = Context;
export const useCutManager = useManager;
export const useCut = useConsumer;
